export const getManageTemplatesUrl = (waba: string) =>
  `https://business.facebook.com/wa/manage/message-templates/?waba_id=${waba}`;
